import { Row, Col } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import React, { useEffect, useState } from 'react';
import { Card } from "react-bootstrap";
import { right } from "@popperjs/core";
import { useApiClient } from "../../ApiService/useApiClient";

const CustomerRiskAssessment = ({ CustomerID, CustomerName }) => {

  const api = useApiClient();
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editingAssessment, setEditingAssessment] = useState(null);
  const [error, setError] = useState(null);
  const [sCustomerName, setCustomerName] = useState(null);

  const tableColumns = [
    {
      name: "Risk Area",
      selector: row => row.riskArea,
      sortable: true,
    },
    {
      name: "Description",
      selector: row => row.description,
      sortable: true,
    },
    {
      name: "Risk Score",
      selector: row => row.riskScore,
      sortable: true,
    },    
    {
      name: "Actions",
      cell: row => (
        <div>
          <Button variant="primary" size="sm" onClick={() => handleEditAssessment(row)}>
            Edit
          </Button>{' '}
          <Button variant="danger" size="sm" onClick={() => handleDeleteAssessment(row.id)}>
            Delete
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      const CompleteURL = `HMCareCustomerRiskAssessment?CustomerID=${CustomerID}`;
      
      try {
        const response = await api.get(CompleteURL);
        setData(response.data);
        setCustomerName(CustomerName);
      } catch (error) {
        setError(error);
      }
    };
    fetchData();
  }, [CustomerID]);

  const [formValue, setFormValue] = useState({
    customerID: CustomerID,
    riskArea: '',
    description: '',
    riskAffectsTo: CustomerName??'',
    planToManageRisk: '',
    likelyhoodRank: '',
    severityRank: '',
    riskScore: ''
  });

  const handleChange = (event) => {
    setFormValue({
      ...formValue,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const sURL = `HMCareCustomerRiskAssessment/add`;
    
    try {
      const response = await api.post(sURL, formValue);
      setData([...data, response.data]);
      handleClose();
    } catch (error) {
      setError(error);
    }
  };

  const handleEditAssessment = (assessment) => {
    setEditingAssessment(assessment);
    setFormValue({
      ...assessment,
      customerID: CustomerID
    });
    setEditMode(true);
    setShow(true);
  };

  const handleUpdateAssessment = async (event) => {
    event.preventDefault();
    const sURL = `HMCareCustomerRiskAssessment/update/${editingAssessment.id}`;
   
    try {
      const response = await api.put(sURL, formValue);
      const updatedData = data.map(item => 
        item.id === response.data.id ? response.data : item
      );
      setData(updatedData);
      handleClose();
    } catch (error) {
      setError(error);
    }
  };

  const handleDeleteAssessment = async (id) => {
    if (window.confirm("Are you sure you want to delete this assessment?")) {
      const sURL = `HMCareCustomerRiskAssessment/delete/${id}`;
    
      try {
        await api.delete(sURL);
        const updatedData = data.filter(item => item.id !== id);
        setData(updatedData);
      } catch (error) {
        setError(error);
      }
    }
  };

  const handleClose = () => {
    setShow(false);
    setEditMode(false);
    setEditingAssessment(null);
    setFormValue({
      customerID: CustomerID,
      riskArea: '',
      description: '',
      riskAffectsTo: '',
      planToManageRisk: '',
      likelyhoodRank: '',
      severityRank: '',
      riskScore: ''
    });
  };

  return (
    <>

<Row className="mb-3">
  <Col className="d-flex justify-content-end">
    <Button 
      variant="outline-primary" 
      onClick={() => setShow(true)} 
      size="sm"
    >
      + Add A Risk
    </Button>
  </Col>
</Row>

<div className="risk-assessment-list">
        {data.map((assessment) => (
          <Card key={assessment.id} className="mb-4 shadow-sm">
            <Card.Body>
              <Row>
                {/* Left Side */}
                <Col md={6}>
                  <div>
                    {/* <h5 className="text-primary">Risk Area: </h5> */}
                    <strong style={{paddingRight:"5px"}}>Risk Area:</strong>{assessment.riskArea}
                  </div>
                  <div style={{ paddingTop:"1px"}}>
                    <strong>Description:</strong>
                    <p>{assessment.description || "N/A"}</p> {/* Description on next line */}
                  </div>
                  <div style={{ paddingTop:"1px"}}>
                    <strong style={{paddingRight:"5px"}}>Who the risk affects:</strong> {assessment.riskAffectsTo || "N/A"}
                  </div>
                  <div style={{ paddingTop:"1px"}}>
                    <strong>Plan to manage/mitigate the risk:</strong>
                    <p>{assessment.planToManageRisk || "N/A"}</p> {/* Plan on next line */}
                  </div>
                </Col>

                {/* Right Side */}
                <Col md={3} className="border-start">
                  <div className="d-flex justify-content-between mb-3">
                    <div className="text-center">
                      <div className="text-muted small"><strong>Likelihood</strong></div>
                      <div className="h4">{assessment.likelyhoodRank || "-"}</div>
                    </div>
                    <div className="text-center">
                      <div className="text-muted small">|</div>                      
                    </div>
                    <div className="text-center">
                      <div className="text-muted small"><strong>Severity</strong></div>
                      <div className="h4">{assessment.severityRank || "-"}</div>
                    </div>
                    <div className="text-center">
                      <div className="text-muted small">|</div>                      
                    </div>
                    <div className="text-center">
                      <div className="text-muted small"><strong>Risk Score</strong></div>
                      <div className="h4 text-danger">{assessment.riskScore || "-"}</div>
                    </div>
                  </div>
                  </Col>

                  {/* Action Buttons */}
                  <Col md={2} className="border-start">
                  <div className="d-flex justify-content-end gap-2">
                    <Button variant="outline-primary" size="sm" onClick={() => handleEditAssessment(assessment)}>
                      Edit
                    </Button>
                    <Button variant="outline-danger" size="sm" onClick={() => handleDeleteAssessment(assessment.id)}>
                      Delete
                    </Button>
                  </div>                  
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
      </div>

      
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>{editMode ? 'Edit Risk Assessment' : 'New Risk Assessment'}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={editMode ? handleUpdateAssessment : handleSubmit}>
            <Modal.Body>
            {/* Existing fields */}
            <Form.Group className="mb-3">
                <Form.Label>Risk area</Form.Label>
                <Form.Control
                name="riskArea"
                value={formValue.riskArea}
                onChange={handleChange}
                required
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={formValue.description}
                onChange={handleChange}
                />
            </Form.Group>

            {/* New fields added here */}
            {/* <Row>
                <Col md={6}> */}
                <Form.Group className="mb-3">
                    <Form.Label>Who the risk affects?</Form.Label>
                    <Form.Control
                    name="riskAffectsTo"
                    value={formValue.riskAffectsTo}
                    onChange={handleChange}
                    />
                </Form.Group>
                {/* </Col>
                <Col md={6}> */}
                <Form.Group className="mb-3">
                    <Form.Label>Plan to manage/mitigate the risk</Form.Label>
                    <Form.Control
                    as="textarea"
                    name="planToManageRisk"
                    value={formValue.planToManageRisk}
                    onChange={handleChange}
                    />
                </Form.Group>
                {/* </Col>
            </Row> */}

            <Row>
                <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Likelihood Rank (1-10)</Form.Label>
                    <Form.Control
                    type="number"
                    min="1"
                    max="10"
                    name="likelyhoodRank"
                    value={formValue.likelyhoodRank}
                    onChange={handleChange}
                    />
                </Form.Group>
                </Col>
                <Col md={6}>
                <Form.Group className="mb-3">
                    <Form.Label>Severity Rank (1-10)</Form.Label>
                    <Form.Control
                    type="number"
                    min="1"
                    max="10"
                    name="severityRank"
                    value={formValue.severityRank}
                    onChange={handleChange}
                    />
                </Form.Group>
                </Col>
            </Row>

            
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Cancel</Button>
            <Button variant="primary" type="submit">
                {editMode ? 'Update' : 'Save'}
            </Button>
            </Modal.Footer>
        </Form>
        </Modal>

    </>
  );
};

export default CustomerRiskAssessment;
